"use client";
import React from "react";
import type { TestimonialProps } from "@/types/sections/testimonial";
import { getBackgroundStyle } from "@/lib/background";

interface Props {
  data: TestimonialProps;
}

export default function TestimonialAvatar({ data }: Props) {
  const {
    title,
    subtitle,
    quotes = [],
    align = "center",
    background = {},
  } = data || {};

  const bgStyle = getBackgroundStyle(background);

  const alignClass =
    align === "center"
      ? "text-center"
      : align === "right"
        ? "text-right"
        : "text-left";

  return (
    <section className="py-20 px-4" style={bgStyle}>
      <div className="max-w-5xl mx-auto">
        {title && (
          <h2
            className={`text-3xl font-bold mb-2 text-foreground ${alignClass}`}
          >
            {title}
          </h2>
        )}
        {subtitle && (
          <p className={`text-muted-foreground mb-10 ${alignClass}`}>
            {subtitle}
          </p>
        )}

        <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2">
          {quotes.map((q, i) => (
            <div
              key={i}
              className="flex gap-4 items-start bg-white p-6 rounded-xl shadow"
            >
              {q.avatar && (
                <img
                  src={q.avatar}
                  alt={q.author}
                  className="w-16 h-16 rounded-full object-cover"
                />
              )}
              <div>
                <p className="italic text-foreground">“{q.quote}”</p>
                <p className="mt-3 font-semibold">{q.author}</p>
                <p className="text-sm text-muted-foreground">{q.role}</p>
                {q.logo && (
                  <img
                    src={q.logo}
                    alt="logo"
                    loading="lazy"
                    className="h-6 mt-2 opacity-70"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
